export default __webpack_public_path__ + "static/media/84.dd59f19a.jpeg";